import { List } from "@material-ui/icons";
import RichTextInput from 'ra-input-rich-text';
import React, { useContext } from "react";
import { Button, Create, FormTab, ReferenceInput, SelectInput, TabbedForm, useRedirect } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";

const ActivityNoteCreate = (props) => {
    const r = useRedirect()
    const { activity, redirectTo, origin } = props.history.location.state
    const context = useContext(AppContext)
    return (
        <>
            <Button
                onClick={() => {
                    r(redirectTo, undefined, undefined, undefined, { origin })
                }}
                label={'Retornar'}
                style={{ alignSelf: 'flex-start' }}
                startIcon={<List />}
            />
            <Create {...props} onSuccess={() => { r(redirectTo, undefined, undefined, undefined, { origin }) }}>
                <TabbedForm initialValues={{ activity: activity, author: context.currentUser.id }} >
                    <FormTab label={'Dados Gerais'}>
                        <ReferenceInput source="author" label={"Autor"} reference="users" fullWidth disabled>
                            <SelectInput optionText={"name"} />
                        </ReferenceInput>
                        <ReferenceInput source="activity" label={"Movimentação"} reference="activities" fullWidth disabled>
                            <SelectInput source="id" optionText={"type.name"} />
                        </ReferenceInput>
                        <RichTextInput source="text" label={'Conteúdo'} fullWidth />
                    </FormTab>
                </TabbedForm>
            </Create >
        </>
    )
}

export default ActivityNoteCreate;